import { useEffect, useState } from 'react';
import { Keyboard } from 'react-native';

/**
 * Hook that returns whether the keyboard is currently visible
 */
export const useIsKeyboardVisible = () => {
  const [isKeyboardVisible, setKeyboardVisible] = useState(false);

  // Effect for iOS/Android keyboard events. Android doesn't have
  // willShow/willHide events so we use didShow/didHide instead.
  useEffect(() => {
    const didShow = Keyboard.addListener('keyboardDidShow', () => setKeyboardVisible(true));
    const didHide = Keyboard.addListener('keyboardDidHide', () => setKeyboardVisible(false));
    return () => {
      didShow.remove();
      didHide.remove();
    };
  }, []);

  // Effect for web visualViewport resize events. Seems to be the best proxy for
  // whether the virtual keyboard is visible on mobile web.
  useEffect(() => {
    if (typeof window !== 'undefined' && window.visualViewport) {
      const resizeHandler = () => {
        if (
          window.visualViewport &&
          window.visualViewport.height < document.documentElement.clientHeight
        ) {
          setKeyboardVisible(true);
        } else {
          setKeyboardVisible(false);
        }
      };

      window.visualViewport.addEventListener('resize', resizeHandler);

      return () => window.visualViewport?.removeEventListener('resize', resizeHandler);
    }
  }, []);

  return isKeyboardVisible;
};
